module.exports = __webpack_public_path__ + "static/media/interview.32c965d5.jpg";